"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var timed_cache_1 = __importDefault(require("timed-cache"));
var cache = new timed_cache_1.default();
exports.msGraphAccessTokenKey = "msGraphAccessTokenKey";
exports.edmsAccessTokenKey = "edmsAccessToken";
exports.dotCodesByCodeTypeKey = "dotCodesByCodeTypeKey";
exports.getCachedAccessToken = function (accessTokenKey) {
    return cache.get(accessTokenKey);
};
exports.cacheAccessToken = function (accessTokenKey, accessToken, secondsBeforeExpire) {
    cache.put(accessTokenKey, accessToken, {
        ttl: 1000 * (secondsBeforeExpire - 10),
    });
};
